import PDF from "./../../assets/icons/pdf.png"
import FILE from "./../../assets/icons/file.png"
import XML from "./../../assets/icons/xml.png"
import ZIP from "./../../assets/icons/zip.png"
import OGGA from "./../../assets/icons/oggA.png"
import OGGV from "./../../assets/icons/oggV.png"
import MPEG from "./../../assets/icons/mpeg.png"
import TEXT from "./../../assets/icons/text.png"
import HTML from "./../../assets/icons/html.png"
import XLSX from "./../../assets/icons/xlsx.png"
import CSV from "./../../assets/icons/csv.png"
import EXEI from "./../../assets/icons/exeI.png"
import GZIP from "./../../assets/icons/gzip.png"
import DOCX from "./../../assets/icons/docx.png"
import DOC from "./../../assets/icons/doc.png"
import JNLP from "./../../assets/icons/jnlp.png" 
import PKCS12 from "./../../assets/icons/pkcs12.png" 
import XLS from "./../../assets/icons/xls.png" 
import MP4 from "./../../assets/icons/mp4.png" 
import MKV from "./../../assets/icons/mkv.png" 
import VCARD from "./../../assets/icons/contact.png" 
import MPEGA from "./../../assets/icons/mpegA.png" 
import JSON from "./../../assets/icons/json.png" 
import MOV from "./../../assets/icons/mov.png" 
import EML from "./../../assets/icons/eml.png" 
import ODS from "./../../assets/icons/ods.png" 
import JS from "./../../assets/icons/js.png" 



export const getIconeFile = (type,file) => {
    if ((type) && (type.indexOf('.') < 0)) {
        switch (type) {
            case 'application/pdf':
                return PDF  
            case 'text/xml' : 
                return XML  
            case 'application/x-zip-compressed' : 
                return ZIP
            case 'audio/ogg' : 
                return OGGA
            case 'video/ogg' : 
                return OGGV
            case 'video/mpeg' : 
                return MPEG
            case 'text/plain' : 
                return TEXT
            case 'text/html' : 
                return HTML
            case 'text/csv' : 
                return CSV
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' :
                return XLSX
            case 'application/x-msdownload':
                return EXEI
            case 'application/x-gzip':
                return GZIP
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                return DOCX
            case 'application/msword':
                return DOC
            case 'application/x-java-jnlp-file':
                return JNLP  
            case 'application/x-pkcs12':
                return PKCS12    
            case 'application/vnd.ms-excel':
                return XLS   
            case 'video/mp4':
                return MP4  
            case 'video/x-matroska':
                return MKV    
            case 'text/x-vcard':
                return VCARD  
            case 'audio/mpeg':
                return MPEGA  
            case 'application/json':
                return JSON  
            case 'video/quicktime':
                return MOV  
            case 'message/rfc822':
                return EML  
            case 'application/vnd.oasis.opendocument.spreadsheet':
                return ODS  
            case 'text/javascript':
                return JS              
            default:
                if (type !== '' )
                    console.log(type, ' | ', file)
                return FILE;
        }
    } else {
        let _extension = type?.slice((type.lastIndexOf(".") - 1 >>> 0) + 2);

        switch (_extension) {
            case 'pdf':
                return PDF  
            case 'xml' : 
                return XML  
            case 'zip' : 
                return ZIP
            case 'ogg' : 
                return OGGA
            case 'mpeg' : 
                return MPEG
            case 'txt' : 
                return TEXT
            case 'html' : 
                return HTML
            case 'csv' : 
                return CSV
            case 'xlsx' :
                return XLSX
            case 'exe':
                return EXEI
            case 'gzip':
                return GZIP
            case 'docx':
                return DOCX
            case 'doc':
                return DOC
            case 'jnlp':
                return JNLP  
            case 'pks':
                return PKCS12    
            case 'xls':
                return XLS   
            case 'mp4':
                return MP4  
            case 'mkv':
                return MKV    
            case 'vcard':
                return VCARD  
            case 'json':
                return JSON  
            case 'mov':
                return MOV  
            case 'eml':
                return EML  
            case 'ods':
                return ODS  
            case 'js':
                return JS              
            default:
                if (type !== '' )
                    console.log(type, ' | ', file)
                return FILE;
        }       
    }
}

